import React, { useMemo, useState } from "react";
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ListFilter } from "lucide-react";
import SearchFiltersAccordion from "./SearchFiltersAccordion";
import { FilterableField, SearchFilterValues } from "./types";
import { ButtonSecondary } from "src/UI/ButtonSecondary";

interface SearchFiltersToggleProps {
  fields: FilterableField[];
  value: SearchFilterValues;
  onApply: (next: SearchFilterValues) => void;
  columns?: 2 | 3 | 4;
  fieldOrder?: string[];
}

const SearchFiltersToggle: React.FC<SearchFiltersToggleProps> = ({
  fields,
  value,
  onApply,
  columns,
  fieldOrder,
}) => {
  const { t } = useTranslation("catalog-v2");
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const hasActiveFilters = useMemo(() => {
    const hasValue = (val: any): boolean => {
      if (val === undefined || val === null || val === "") return false;
      if (Array.isArray(val)) return val.length > 0;
      if (typeof val === "object") return Object.values(val).some(hasValue);
      return true;
    };
    return Object.values(value || {}).some(hasValue);
  }, [value]);

  const highlighted = hasActiveFilters || open;

  return (
    <Box>
      <ButtonSecondary
        size="md"
        startIcon={<ListFilter size={16} />}
        onClick={() => setOpen((prev) => !prev)}
        sxButton={
          highlighted
            ? {
                borderColor: theme.palette.systemSecondary01,
              }
            : undefined
        }
      >
        {t("filters-button")}
      </ButtonSecondary>

      <SearchFiltersAccordion
        open={open}
        onClose={() => setOpen(false)}
        fields={fields}
        fieldOrder={fieldOrder}
        value={value}
        onApply={onApply}
        columns={columns}
      />
    </Box>
  );
};

export default SearchFiltersToggle;
